// File: src/App.js
// Description: Main App component that sets up theming, authentication context, routing, and error boundaries.

import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import { AuthProvider } from './context/AuthContext';
import { AIProvider } from './context/AIContext';
import AppRoutes from './routes/AppRoutes';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
  return (
    // ThemeProvider applies our custom Material UI theme across the app.
    <ThemeProvider theme={theme}>
      {/* CssBaseline to provide a consistent baseline for styles */}
      <CssBaseline />
      <AuthProvider>
        <AIProvider>
          <BrowserRouter>
            {/* Global error boundary to catch runtime errors */}
            <ErrorBoundary>
              <AppRoutes />
            </ErrorBoundary>
          </BrowserRouter>
        </AIProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
